export default __webpack_public_path__ + "static/media/logo-light.5159f56a.png";